var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighestUsageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.3333,
    height: 24,
    transform: "translate(-0.347656 0.75)",
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.53467,
    y: 0.75,
    width: 5.56895,
    height: 24,
    fill: "inherit"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4958,
    y: 13.4551,
    width: 5.56895,
    height: 11.2941,
    fill: "inherit"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.57349,
    y: 9.2207,
    width: 5.56895,
    height: 15.5294,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.565165 19.8913L-0.467893 20.3845L0.0247634 20.2846C4.73666 19.329 8.49943 15.7439 9.73539 11.0441L10.8305 6.88C11.2384 5.3286 13.3996 5.3286 13.8076 6.88L14.9026 11.0441C16.1386 15.7439 19.9014 19.329 24.6133 20.2846L25.1059 20.3845L25.2032 19.8913L25.4762 18.5069L25.5725 18.019L25.0851 17.9202C21.2725 17.1469 18.219 14.2437 17.215 10.426L16.1199 6.26191C15.083 2.31894 9.55502 2.31895 8.51811 6.26191L7.42304 10.426C6.41906 14.2437 3.36555 17.1469 -0.447036 17.9202L-0.934442 18.019L-0.838206 18.5069L-0.565165 19.8913Z",
    fill: "inherit",
    stroke: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4958 13.4551V23.0833H22.0648V18.0067C19.7055 17.0559 17.7516 15.4578 16.4958 13.4551Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1036 9.60997L14.2912 6.52076C13.7525 4.47225 10.8857 4.47224 10.347 6.52076L9.53467 9.6097V24.5173H15.1036V9.60997Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57349 18.6752V24.4972H8.14244V13.4551C6.88668 15.7519 4.93285 17.5847 2.57349 18.6752Z",
    fill: "inherit"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighestUsageIcon);
export default __webpack_public_path__ + "static/media/HighestUsageIcon.69fd947d0abaab72b7f5f3230e3ec12d.svg";
export { ForwardRef as ReactComponent };